import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CmsConfig, FeaturesConfigModule, I18nModule, OccProductSearchAdapter, UrlModule, provideDefaultConfig } from "@spartacus/core";
import { OutletModule, IconModule, ItemCounterModule, AtMessageModule, ListNavigationModule, MediaModule, PageComponentModule, ProductListModule, SpinnerModule, StarRatingModule} from "@spartacus/storefront";
import { ReactiveFormsModule } from "@angular/forms";
import { KbCrossRefComponent } from "./kb-cross-ref-list-item.component";
import { RouterModule } from "@angular/router";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { KbAddToCartModule } from "../../kb-add-to-cart/kb-add-to-cart.module";
import { compareCheckBoxModule } from "../check-box-compare/compareCheckBox.module";
import { KbPipesModule } from "src/app/pipes/kb-pipes.module";

@NgModule({
 imports:[
    AtMessageModule,
    CommonModule,
    FeaturesConfigModule,
    I18nModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    ProductListModule,
    KbAddToCartModule,
    compareCheckBoxModule,
    KbPipesModule
 ],
 providers: [OccProductSearchAdapter
  ],
  exports:[KbCrossRefComponent],
 declarations:[KbCrossRefComponent]
})
export class KbCrossRefModule {

}
